"use client";

import { useTranslations } from "next-intl";
import { threeSixtyCam } from "../../../../public/images/three-sixty";
import StepContainer from "./StepContainer";

const StepTwo = () => {
  const t = useTranslations("threeSixtySteps.steps");

  return (
    <div className="bg-secondary">
      <div className="gs--page-column py-16">
        <StepContainer
          title={t("step2.title")}
          text={t("step2.text")}
          src={threeSixtyCam}
          alt={"360 Grad Rundgang Kamera"}
          imageLeft
          sizes="(max-width: 768px) 100vw, (max-width: 1024px) 300vw, 300vw"
        />
      </div>
    </div>
  );
};

export default StepTwo;
